<div style="margin-top:-60px;">
  <ng-container *ngIf="!eventService.loadEventTournaments;else loading">
  
    <mat-tab-group class="spring-tabs">
  
      <div class="snow"></div>

      <mat-tab label="tab2">
        <ng-template mat-tab-label>
          <i class="icon icon-shield"></i>
          Tournaments
        </ng-template>

        <div class="container">
         <div style="margin:10px 0;" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">
          <div class="col-sm-6">
            <a class="tag-container"
               [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}"
               href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank">
              <div class="overlay-cover {{gameName}}"></div>

              <div class="tag-text tag-3-text">

  
                    <div class="text">
                      <h1>{{tournament.name}}</h1>

                      <div class="status" style="display: flex; justify-content: flex-start; align-items: center;">
                        <div class="icon"
                             [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>
                        <p>{{tournament.status}}</p>


                        <p style="margin-left:auto;">
                          <i class="icon-calendar"></i>
                          {{globalService.Date(tournament.start_at)}}

                          <i class="icon-clock"></i>
                          {{globalService.Time(tournament.start_at)}}
                        </p>
                      </div>
  
                    </div>
  
                  </div>
            </a>
  
          </div>
        </div>
        </div>
  
      </mat-tab>
  


    </mat-tab-group>

  
    <div class="big_block points" *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
      <div class="content text-center">
        <p>No Tournaments yet.</p>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
  </ng-template>
  </div>

